import React from "react";

import { StyleSheet, View, Text, Platform } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export const FooterDivider = () => {

    const { centered } = useStyles();

    // Disable for web view
    if (Platform.OS === "web") {
        return null;
    }

    return (
        <SafeAreaView style={{ flex: 1 }} edges={["bottom"]}>
            <View style={centered}>
                <Text style={{ color: "#10632B" }}>___________________</Text>
            </View>
        </SafeAreaView>
    );
};

export default FooterDivider;

FooterDivider.propTypes = {};

const useStyles = () => StyleSheet.create({
    centered: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    }
});